import { t } from 'element-ui/src/locale';

export default {
  methods: {
    t(...args) {
      return t.apply(this, args);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/src/mixins/locale.js
// module id = 965
// module chunks = 0